import { TwoColumnCtaFragmentFragment } from '../../__generated__/graphql';
import AppImage from '../../components/AppImage';
import ButtonLink from '../../components/Button/ButtonLink';
import { Heading2, Heading3 } from '../../components/Text';
import Section from '../../layout/Section';
import { ContentBlock } from '../types';

import style from './two-column-cta.module.css';

const TwoColumnCta: ContentBlock<TwoColumnCtaFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.twoColumnCta;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <Section
      backgroundColor="white"
      id={contentBlockProps.sectionId}
      innerContainerClassName={style.sectionContainer}
    >
      <div className={style.contentContainer}>
        <div className={style.leftColumn}>
          <Heading2
            fontSizeOverride={48}
            fontWeight={300}
          >
            {contentBlockProps.title}
          </Heading2>

          <Heading3
            className={style.subTitle}
            fontSize={22}
            fontWeight={300}
          >
            {contentBlockProps.subtitle}
          </Heading3>

          <ButtonLink
            buttonColor="black"
            id={contentBlockProps.buttonId ?? undefined}
            linkFragment={contentBlockProps.button}
          />
        </div>

        <div>
          {contentBlockProps.image && (
            <AppImage
              fallbackHeight={400}
              fallbackWidth={400}
              image={contentBlockProps.image}
            />
          )}
        </div>
      </div>
    </Section>
  );
};

export default TwoColumnCta;
